import { module } from 'angular';
import { isErrorInterceptor } from './is-error.interceptor';

export const CoreInterceptorsModule = module('app.core.interceptors', [])
  .factory('isErrorInterceptor', isErrorInterceptor);



// WEBPACK FOOTER //
// ./app/core/interceptors/core-interceptors.module.ts